<app-home-navigation></app-home-navigation>
<main>
    <picture class="free-trial-picture" >
        <source srcset="https://storage.googleapis.com/artifacts-healingourvillages/Pricing/madison-lavern-4gcqRf3-f2I-unsplash.webp" type="image/webp">
        <img src="https://storage.googleapis.com/artifacts-healingourvillages/Pricing/madison-lavern-4gcqRf3-f2I-unsplash.jpg" width="1310" height="591" type="image/jpeg">
    </picture>
    <div class="price-container">
            
            <section class="price-section">
                    <header>
                        <h3>Basic Package</h3>
                        <h5>$<strong>5.99</strong>/mo.</h5>
                    </header>
                    <ul>
                        <li>Interactive Calendar of Events</li>
                        <li>Weekly LIVE Zoom workshops with a HOV CDC Certified Lifestyle Coach</li>
                        <li>Video Library on Healthy Eating</li>
                        <li>CDC Approved Curriculum</li>
                        <li>Healthy Recipes</li>
                    </ul>
                </section>
                <section class="price-section">
                        <header>
                            <h3>Premium Package</h3>
                            <h5>$<strong>19.99</strong>/mo.</h5>
                        </header>
                        <ul>
                            <li>Interactive Calendar of Events</li>
                            <li>Weekly LIVE Zoom workshops with a HOV CDC Certified Lifestyle Coach</li>
                            <li>Live Chat with your Personal Lifestyle Coach</li>
                            <li>Weekly Internet Exercise Classes (i.e. Zumba, Yoga, Aerobics, Weight Training, Corder Pounders)</li>
                            <li>CDC Approved Curriculum</li>
                            <li>Healthy Recipes</li>
                            <li>Monthly Cooking Demonstrations</li>
                            <li>Video Library on Healthy Eating</li>
                            <li>Giveaways and Prizes for Achieving Weight Loss and Exercise Goals</li>
                            <li>Access to Personal Consultations from Clinical Pharmacist, Certified Diabetes Educators and/or Dieticians</li>
                        </ul>
                </section>
                <section class="trial-box flex-column">
                        <h3>Enjoy our app for 30 days, on us.</h3>
                        <div class="btn-container">
                            <button mat-raised-button [ngClass]="{'selected' : selectedPlan === 'basic'}" (click)="selectedPlan = 'basic'">
                                <div class="flex-column">
                                    <small>Basic</small>
                                    <span>$5.99/mo.</span>
                                </div>
                            </button>
                            <button mat-raised-button [ngClass]="{'selected' : selectedPlan === 'premium'}" (click)="selectedPlan = 'premium'">
                                <div class="flex-column">
                                    <small>Advanced</small>
                                    <span>$19.99/mo.</span>
                                </div>
                            </button>
                        </div>
                        <aside class="main-font-dark">No charge will be applied today, this card will be charged unless cancelled in 30 days.</aside>
                        <div class="trial-button">
                            <a mat-raised-button routerLink="/login"class="brown-white">Start Trial</a>
                        </div>
                </section>
        
    </div>
    
</main>